export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5269.78c783f5.jpg";